import React from 'react';

interface IconProps {
  className?: string;
  size?: number;
}

export const ObstaclesIcon: React.FC<IconProps> = ({ className, size = 24 }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.5"
    strokeLinecap="round"
    strokeLinejoin="round"
    className={className}
  >
    {/* Obstacles - various barriers */}
    <path d="M2 20h20" />
    <rect x="4" y="14" width="4" height="6" />
    <path d="M11 20v-8l3 4 3-4v8" />
    <circle cx="6" cy="10" r="2" />
    <path d="M18 12l2 8" />
    <path d="M20 12l-2 8" />
  </svg>
);
